<template>
<div>
  <p v-if="sbpsPaymentError" style="font-size:11px;line-height:1" class="u-tx-danger">申し訳ありませんがご入力頂いたカード情報は現在利用できません。</p>
  <p class="fesPaymentCard__img">
    <img width="160" src="https://websmart.zappallas.com/web_image?url=http%3A%2F%2Fwebpayment.smart-srv%2Fimage%3Fid%3D11315" alt="card">
  </p>
  <form ref="form"
    :method="method"
    :action="action"
    @submit.prevent="handleSubmit"
    scope="credit-card-form">
        <input type="hidden" name="_token" :value="token">
        <input type="hidden" name="cpno" :value="cpno">
        <input type="hidden" name="order_id" :value="orderId">
        <input type="hidden" name="merchant_id" :value="merchantId">
        <input type="hidden" name="service_id" :value="serviceId">
        <input type="hidden" name="token" ref="token">
        <input type="hidden" name="tokenKey" ref="tokenKey">
        <input type="hidden" name="cardbrandCode" ref="cardbrandCode">
        <form-credit-card-fes
          label="カード番号"
          name="ccNumber"
          v-model="ccNumber"
          :validation="{ rules: {
            required: true,
            credit_card: true
          } }"
          placeholder="例）1234 5678 91234"
        ></form-credit-card-fes>
        <input type="hidden" ref="ccNumber" name="cc_number">

        <form-credit-expire-fes
          name=""
          label="カード有効期限"
          month-name="cc_expiration_m"
          year-name="cc_expiration_y"
          v-model="ccExpiration"
          :validation="{ rules: {
            required: true
          } }"
        ></form-credit-expire-fes>

        <div class="securityCode formGroup">
          <form-input-fes
            label="セキュリティコード"
            name="security_code"
            v-model="securityCode"
            type="tel"
            placeholder="例）123"
            input-width="120px"
            :validation="{ rules: {
              required: true,
              max: 4
            } }"
          ></form-input-fes>
        </div>
          <!--
          <div class="securityCode__question" @click="toggleAboutSecurityCode">
            <img width="20" height="20" src="/static/img/icons/question.svg">
          </div>
          <div class="securityCode__about media" :data-visible="visibleAboutSecurityCode">
            <div class="media__image">
              <img src="/static/img/security-code.png" width="48" height="30">
            </div>
            <div class="media__content">
              <p>セキュリティコードはカード裏面に記載されている３桁または、表面に記載されている４桁の番号です。</p>
            </div>
          </div>-->
        <label class="confirmTerms  u-mb-t-2">
          <input type="checkbox"
            class="confirmTerms__checkbox"
            name="cust_manage_flg"
            value="1"
            checked
          >
          <span class="confirmTerms__label">カード情報を登録する</span>
        </label>

    <slot></slot>

    <button class="fesBtn" type="submit" @click="handleSubmit"
    data-block="true"
    data-color="pink_active">次へ</button>
  </form>
</div>
</template>

<script>
export default {
  name: 'credit-card-form-fes',
  data() {
    return {
      ccNumber: '',
      ccExpiration: {},
      securityCode: '',
      token: window.Laravel.csrfToken,
      cpno: window.Laravel.cpno,
      tokenResponse: {},
      sbpsPaymentError: false,
      visibleAboutSecurityCode: false
    }
  },
  props: {
    method: String,
    action: String,
    orderId: String,
    merchantId: String,
    serviceId: String,
    custManageFlg: [String, Number]
  },
  methods: {
    toggleAboutSecurityCode() {
      this.visibleAboutSecurityCode = !this.visibleAboutSecurityCode
      if (this.visibleAboutSecurityCode) {
        setTimeout(this.toggleAboutSecurityCode, 5000)
      }
    },
    afterGenerateToken(response) {
      if (response.result == 'OK') {
        this.sbpsPaymentError = false
        const { tokenResponse } = response
        this.$refs.token.value = tokenResponse.token
        this.$refs.tokenKey.value = tokenResponse.tokenKey
        this.$refs.cardbrandCode.value = tokenResponse.cardbrandCode
        // カード情報をマスクされた番号で上書き
        this.$refs.ccNumber.value = tokenResponse.maskedCcNumber
        this.$refs.form.submit()
      } else {
        this.sbpsPaymentError = true
      }
    },
    handleSubmit($event) {
      $event.preventDefault()
      this.$validator.validateAll().then(result => {
        if (result === false) {
          const errors = this.$validator.errors.items
          const $errorsElm = $(`[data-vv-id="${errors[0].id}"]`)
          let top = 0
          if ($errorsElm.css('display') === 'none') {
            $errorsElm
              .css({
                height: '1px'
              })
              .show()
            top = $errorsElm.offset().top
            $errorsElm.hide()
          }
          console.log(top);
          $('html, body').animate(
            {
              scrollTop: $errorsElm[0] ? top : 0
            },
            300
          )
        } else {
          window.com_sbps_system.generateToken(
            {
              merchantId: this.merchantId,
              serviceId: this.serviceId,
              ccNumber: this.ccNumber,
              ccExpiration: `20${this.ccExpiration.year}${
                this.ccExpiration.month
              }`,
              securityCode: this.securityCode
            },
            this.afterGenerateToken
          )
        }
      })
    }
  }
}</script>

<style lang="scss" scoped>
.securityCode {
  position: relative;
  &__question {
    position: absolute;
    left: 88px;
    top: 35px;
    cursor: pointer;
  }
  &__about {
    position: absolute;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    padding: 8px;
    z-index: 2;
    box-shadow: rgba(0, 0, 0, 0.2) 0px 2px 4px;
    border-radius: 4px;
    left: 120px;
    top: 0;
    align-items: center;
    pointer-events: none;
    opacity: 0;
    transition: opacity 250ms ease-in-out;
    &[data-visible='true'] {
      opacity: 1;
      pointer-events: auto;
    }
    .media__content p {
      font-size: 10px;
      line-height: 14px;
    }
  }
}

.fesBtn {
  display: block;
  width: 100%;
  border: 2px solid #e4007f;
  background: #e4007f;
  box-shadow: none;
  color: #fff;
  text-align: center;
  padding: 12px 0;
  margin: 24px 0;
  border-radius: 24px;
  font-weight: bold;
  cursor: pointer;
  font-size: 16px;
  // &[aria-disabled="true"] {
  //   background: #D8D8D8;
  //   border: 2px solid #D8D8D8;
  //   cursor: not-allowed;
  //   pointer-events: none;
  // }
}

.confirmTerms {
  justify-content: left;
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/uFes/components/CreditCardFormFes.vue